module.exports = __webpack_public_path__ + "media/styles/images/svg/baruch-logo-3dcc7c9975449618e10f7ad3a0baf19c.svg";